module.exports = __webpack_public_path__ + "static/media/butterfly2.887c3c89.svg";